import type { ChatMessage, ChatbotReferenceImage, ChatbotTurn } from "../../services/chatbot.service";
import type { WidgetMessage } from "./types";
import {
  ASSISTANT_ROLE,
  MAX_CONTEXT_MESSAGES,
  USER_ROLE,
  WELCOME_MESSAGE_TRANSLATION_KEY,
} from "./chatbotHook.constants";

type ChatbotRole = WidgetMessage["role"];

export const createMessage = (
  role: ChatbotRole,
  content: string,
  localOnly = false,
  translationKey: string | null = null,
  referenceImages: ChatbotReferenceImage[] = []
): WidgetMessage => ({
  id: `${role}-${Date.now()}-${Math.random().toString(16).slice(2)}`,
  role,
  content,
  localOnly,
  translationKey,
  ...(referenceImages.length ? { referenceImages } : {}),
});

export const createWelcomeMessage = (): WidgetMessage =>
  createMessage(ASSISTANT_ROLE, "", true, WELCOME_MESSAGE_TRANSLATION_KEY);

export const createTurnMessages = (sessionId: string, turns: ChatbotTurn[]): WidgetMessage[] =>
  turns.flatMap((turn) => [
    {
      id: `${sessionId}-turn-${turn.turn_index}-user`,
      role: USER_ROLE,
      content: turn.question.content,
      localOnly: false,
      translationKey: null,
      sessionId,
      turnId: turn._id,
      referenceImages: turn.question.reference_images ?? [],
    },
    {
      id: `${sessionId}-turn-${turn.turn_index}-assistant`,
      role: ASSISTANT_ROLE,
      content: turn.answer.content,
      localOnly: false,
      translationKey: null,
      sessionId,
      turnId: turn._id,
      toolCalls: turn.answer.tool_calls ?? [],
    },
  ]);

export const buildRequestMessages = (
  messages: WidgetMessage[],
  userMessage: WidgetMessage
): ChatMessage[] =>
  [...messages, userMessage]
    .filter((message) => !message.localOnly && message.content.trim())
    .slice(-MAX_CONTEXT_MESSAGES)
    .map((message) => ({
      role: message.role,
      content: message.content,
      ...((message.referenceImages?.length ?? 0) > 0
        ? { reference_image_urls: message.referenceImages!.map((image) => image.image_url) }
        : {}),
    }));
